// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
// Calculation modes of MA indicator
export var MAMode;
(function (MAMode) {
    // Simple moving average calculation
    MAMode[MAMode["SMA"] = 0] = "SMA";
    // Exponential moving average calculation
    MAMode[MAMode["EMA"] = 1] = "EMA";
    // Smoothed moving average calculation
    MAMode[MAMode["SMMA"] = 2] = "SMMA";
    // Linear weighted moving average calculation
    MAMode[MAMode["LWMA"] = 3] = "LWMA";
})(MAMode || (MAMode = {}));
export const MAModeMap = Object.fromEntries(Object.entries(MAMode).map(([k, v]) => [v, k]));
Object.freeze(MAModeMap);
export var GradientMode;
(function (GradientMode) {
    // Simple moving average RSI calculation
    GradientMode[GradientMode["None"] = 0] = "None";
    // Exponential RSI calculation
    GradientMode[GradientMode["Simple"] = 1] = "Simple";
    // Wilder`s moving average
    GradientMode[GradientMode["Linear"] = 2] = "Linear";
})(GradientMode || (GradientMode = {}));
export var RSIMode;
(function (RSIMode) {
    // Simple moving average RSI calculation
    RSIMode[RSIMode["Simple"] = 0] = "Simple";
    // Exponential RSI calculation
    RSIMode[RSIMode["Exponential"] = 1] = "Exponential";
    // Wilder`s moving average
    RSIMode[RSIMode["WMA"] = 2] = "WMA";
})(RSIMode || (RSIMode = {}));
export var AlligatorMode;
(function (AlligatorMode) {
    AlligatorMode[AlligatorMode["Jaw"] = 0] = "Jaw";
    AlligatorMode[AlligatorMode["Teeth"] = 1] = "Teeth";
    AlligatorMode[AlligatorMode["Lips"] = 2] = "Lips";
})(AlligatorMode || (AlligatorMode = {}));
export var IchimokuMode;
(function (IchimokuMode) {
    IchimokuMode[IchimokuMode["Tenkansen"] = 0] = "Tenkansen";
    IchimokuMode[IchimokuMode["Kijusen"] = 1] = "Kijusen";
    IchimokuMode[IchimokuMode["Senkouspana"] = 2] = "Senkouspana";
    IchimokuMode[IchimokuMode["Senkouspanb"] = 3] = "Senkouspanb";
    IchimokuMode[IchimokuMode["Chinkouspan"] = 4] = "Chinkouspan";
})(IchimokuMode || (IchimokuMode = {}));
export const MODE_MAIN = 0;
export const MODE_SIGNAL = 1;
export const MODE_MINUSDI = 1;
export const MODE_PLUSDI = 2;
export const MODE_UPPER = 0;
export const MODE_LOWER = 1;
export var FractalsAggregationType;
(function (FractalsAggregationType) {
    FractalsAggregationType[FractalsAggregationType["Current"] = 0] = "Current";
    FractalsAggregationType[FractalsAggregationType["Custom"] = 1] = "Custom";
})(FractalsAggregationType || (FractalsAggregationType = {}));
export var FractalsPeriod;
(function (FractalsPeriod) {
    FractalsPeriod[FractalsPeriod["Second"] = 0] = "Second";
    FractalsPeriod[FractalsPeriod["Minute"] = 1] = "Minute";
    FractalsPeriod[FractalsPeriod["Hour"] = 2] = "Hour";
    FractalsPeriod[FractalsPeriod["Day"] = 3] = "Day";
    FractalsPeriod[FractalsPeriod["Week"] = 4] = "Week";
    FractalsPeriod[FractalsPeriod["Month"] = 5] = "Month";
    FractalsPeriod[FractalsPeriod["Year"] = 6] = "Year";
})(FractalsPeriod || (FractalsPeriod = {}));
